module.exports = __webpack_public_path__ + "static/media/john-skeet.c747ed03.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/john-skeet.png
// module id = 271
// module chunks = 0